<script lang="ts">
  interface Props {
    children?: import('svelte').Snippet
  }

  let { children }: Props = $props()
</script>

<div class="skeleton">
  {@render children?.()}
</div>

<style lang="postcss">
  @keyframes skeleton-loading {
    0% {
      background-position: 200% 0%;
    }
    100% {
      background-position: 0% 0%;
    }
  }

  .skeleton {
    display: contents;
    :global(:not(.wrapper)) {
      --_default-color: var(--color-bg);
      --_shimmer-color: var(--color-bg);
      animation: skeleton-loading 2s ease-out infinite;
      background-position: 200% 0%;
      background: linear-gradient(
        100deg,
        var(--_default-color),
        var(--_default-color) 50%,
        var(--_shimmer-color) 60%,
        var(--_default-color) 70%
      );
      background-size: 200% 100%;
      background-attachment: fixed;
    }
  }
</style>
